<app-layout size="100%">
  <app-breadcrumb [breadcrumbItems]="[
  { label: ('breadcrumb.login' | translate), link: '/' },
  { label: ('breadcrumb.resetPassword' | translate) }
]"></app-breadcrumb>
  <div class="change-password-container">
    <div class="form-section">
      <app-title title="changePassword.header" />

      @if (tokenValid === null) {
      <app-spinner></app-spinner>
      }

      @if (tokenValid === false) {
      <div class="error" data-testid="reset-password-expired-token">
        {{ 'updatePassword.expiredTokenError' | translate }}
      </div>
      }

      @if (tokenValid === true) {
      <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">

        <app-input [label]="'changePassword.newPassword' | translate" [formGroup]="passwordForm" name="newPassword"
          type="password" [required]="true" (input)="checkPassword()"></app-input>

        <app-input [label]="'changePassword.confirmPassword' | translate" [formGroup]="passwordForm"
          name="confirmPassword" type="password" [required]="true"></app-input>

        @if (passwordMismatch) {
        <div class="error">
          {{ 'changePassword.passwordMismatch' | translate}}
        </div>
        }

        @if (apiError) {
        <div class="error">
          @if (apiError.translationKey) {
          {{ apiError.translationKey | translate }}
          } @else {
          {{ apiError.rawMessage }}
          }
        </div>
        }

        @if (success) {
        <div id="password-change-success" class="success">
          {{ 'updatePassword.success' | translate}}
          <a routerLink="/" queryParamsHandling="preserve" class="goBack">{{ 'updatePassword.clickHere' |
            translate}}</a>
        </div>
        }

        <div class="button-group">
          @if (submitting) {
          <app-spinner></app-spinner>
          } @else {
          <app-button variant="primary">
            <button type="submit" data-testid="reset-password-submit"
              [disabled]="!passwordForm.valid || passwordMismatch || button_clicked">{{
              'changePassword.changePasswordInput' | translate }}</button>
          </app-button>
          }

          <app-button variant="secondary">
            <a routerLink="/" queryParamsHandling="preserve" class="btn btn-secondary">{{
              'changePassword.cancel' | translate }}</a>
          </app-button>
        </div>
      </form>
      }

    </div>

    <div class="requirements-section">
      <app-password-requirements [validations]="validations" />
    </div>

  </div>
</app-layout>